import React, { useState } from 'react'
import AuthRequiredModal from 'src/pages/inventario/modals/Auth/AuthRequiredModal/AuthRequiredModal'
import useAuth, { RoleNames } from 'src/shared/hooks/useAuth'

const useModalAuthExtensionEstancia = ({onConfirm}: {onConfirm: () => void}) => {
    const [isOpen, setisOpen] = useState(false)
    const { Modal } = useAuth({
        authModal: (
            <AuthRequiredModal
                isOpen={isOpen}
                authorizedRoles={[RoleNames.superadmin, RoleNames.admin, RoleNames.gerente]}
                onClose={() => setisOpen(false)}
                onAuthFilled={() => {
                    onConfirm()
                    setisOpen(false)
                }}
            />
        ),
        authorizedRoles: [RoleNames.superadmin, RoleNames.admin, RoleNames.gerente, RoleNames.recepcionista],
        noNeedAuthModalRoles: [RoleNames.superadmin, RoleNames.admin, RoleNames.gerente],
        isOpen: isOpen,
        onClose: () => setisOpen(false),
    })
    return {
        setisAuthModalOpen: setisOpen,
        Modal,
    }
}

export default useModalAuthExtensionEstancia